import enMessages from '../locales/en_US.json';
import merchandisingMessages from '../locales/merchandising';

const EnLang = {
  messages: {
    ...enMessages,
    ...merchandisingMessages,
  },
  locale: 'en-US',
};
export default EnLang;
